import React, { useState, startTransition, useEffect } from "react";
import Header from "../../components/Header/index";
import Send from "../../assets/Icons/Send";
import { RiVoiceprintLine } from "react-icons/ri";
import { FaPlay, FaPause } from "react-icons/fa";
import Topbar from "../../components/Topbar";
import Bottombar from "../../components/Bottombar";

import Scene from "../../components/Animation";
import {ReactComponent as SelectorIcon} from "../../assets/svgs/selector.svg"; 

function TextAndSpeachToSignLanguage() {
  const [showmic, setMic] = useState(false);
  const [showScene, setShowScene] = useState(false);
  const [playAnimation, setPlayAnimation] = useState(0);
  const [inputText, setInputText] = useState("");
  const [conversation, setConversation] = useState([]);
  const [isAnimationPaused, setIsAnimationPaused] = useState(false);
  const [isAnimationPlaying, setIsAnimationPlaying] = useState(false);
  
  // Conversation data structure:
  // {
  //   id: string,
  //   type: 'user' | 'animation',
  //   timestamp: Date,
  //   content: string, // for user messages
  //   actions?: string[], // for animation responses - list of animation actions played
  //   animationName?: string // name of the main animation used
  // }

  useEffect(() => {
    if (!showScene) {
      startTransition(() => {
        setShowScene(true);
      });
    }
  }, [showScene]);

  const startrecording = () => {
    setMic(!showmic);
  };

  const addUserMessage = (text) => {
    const userMessage = {
      id: Date.now().toString() + '_user',
      type: 'user',
      timestamp: new Date(),
      content: text
    };
    const animationResponse = {
      id: Date.now().toString() + '_animation',
      type: 'animation',
      timestamp: new Date(),
      actions: ['export_root|Take 001|BaseLayer'], // Using the animation name we found: will be dynamic in real use
      animationName: 'Sign Language Response'
    };
    
    setConversation(prev => [...prev, userMessage, animationResponse]);
    setPlayAnimation(prev => prev + 1); // Trigger animation with incrementing value
  };

  const handleSendMessage = () => {
    if (inputText.trim()) {
      addUserMessage(inputText.trim());
      setInputText("");
    }
  };

  const clearConversation = () => {
    setConversation([]);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Text to Sign Language");
  const options = [
    { label: "Sign language to text ", link: "/signlanguagetotext" },
    { label: "Text to sign langauge", link: "/textandspeechtosignlanguage" },
    { label: "Speech to Sign Language", link: "/SpeachToSignLanguage" },
  ];

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    setIsOpen(false);
    // Navigate to the selected option's link
    window.location.href = option.link;
  };

  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <div className="hidden md:block">
        <Header />
      </div>

      <div className="sm:hidden fixed top-0 left-0 right-0 z-40 bg-white dark:bg-black">
        <Topbar />
      </div>

      <div className="flex flex-col sm:flex-row sm:mt-4 mt-16 sm:space-x-5 sm:mb-3 sm:mx-6 sm:ml-3 sm:px-0 px-2 pb-24 sm:pb-4">
        <div className="w-[578px]  h-[550px] bg-bgimage2  hidden md:block  rounded-[31px]  bg-[#417FEA1C] bg-center justify-cener items-center  relative  mt-0">
          <div className="relative inline-block text-left">
            <div
              onClick={toggleDropdown}
              className="w-full h-10 items-center flex sm:w-[578px] z-40 cursor-pointer justify-end bg-[#2A71E8] rounded-[31px] top-5"
            >
              <div className="items-center space-x-32 flex px-10">
                <p className="text-white font-bold">{selectedOption}</p>
                <SelectorIcon />
              </div>
            </div>

            {isOpen && (
              <div className="absolute right-0 mt-2 w-full ring-1 z-40 ring-black ring-opacity-0 space-y-10 h-[56px]">
                <div className="py-1 space-y-2 rounded-[25px] items-center px-5">
                  {options.map((option) => (
                    <button
                      key={option.label}
                      onClick={() => handleOptionClick(option)}
                      className="w-full bg-[#D9D9D9] px-4 py-2 rounded-[25px] h-10 items-center justify-center flex space-y-5 text-left text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className=" items-center justify-center ml-4 mr-4 hidden md:block">
            {/* Conversation Display */}
            <div className="absolute top-[80px] left-[20px] right-[20px] bottom-[140px] overflow-y-auto bg-gray-50 rounded-lg p-4 border">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Conversation</h3>
                <button 
                  onClick={clearConversation}
                  className="bg-red-500 text-white px-3 py-1 rounded-lg hover:bg-red-600 transition-colors text-sm"
                >
                  Clear Chat
                </button>
              </div>
              
              {conversation.length === 0 ? (
                <div className="text-center text-gray-500 mt-8">
                  <p>Start a conversation by typing a message below</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {conversation.map((message) => (
                    <div key={message.id} className={`flex ${message.type === 'user' ? 'justify-start' : 'justify-end'}`}>
                      <div className="flex flex-col max-w-xs">
                        <div className={`px-4 py-2 rounded-lg ${
                          message.type === 'user' 
                            ? 'bg-blue-500 text-white' 
                            : 'bg-green-500 text-white'
                        }`}>
                          {message.type === 'user' ? (
                            <p>{message.content}</p>
                          ) : (
                            <div className="flex items-center justify-between">
                              <p className="text-sm font-semibold">{message.animationName}</p>
                              <button 
                                onClick={() => setPlayAnimation(prev => prev + 1)}
                                className="bg-white/20 hover:bg-white/30 rounded p-1 ml-2"
                              >
                                <FaPlay size={12} />
                              </button>
                            </div>
                          )}
                        </div>
                        <p className="text-xs text-gray-500 mt-1 text-center">
                          {message.timestamp.toLocaleTimeString()}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <div
              className={`flex absolute top-[490px] left-4 space-x-4 ${
                showmic ? "hidden" : ""
              } `}
            >
              <input
                type="text"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
                placeholder="Type your message here..."
                className="rounded-[20px] bg-white border border-gray-300 text-gray-800 px-4 py-2 placeholder:text-gray-500 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all w-[471px] h-[40px]"
              />
              <div 
                onClick={handleSendMessage}
                className="bg-[#053676] w-[40px] h-[40px] rounded-full justify-center items-center  flex cursor-pointer hover:bg-[#064284] transition-colors"
              >
                <Send />
              </div>
            </div>

            <div
              className={`flex absolute top-[490px] left-10 space-x-2  items-center justify-center ${
                showmic ? "" : "hidden"
              } `}
            >
              <progress
                className="progress progress-primary bg-[#878787] w-[400px]"
                value="70"
                max="100"
              ></progress>
              <div className="bg-[#D9D9D9] w-[90px] h-[20px] rounded-[20px] opacity-40 items-center   ">
                <div className="flex items-center justify-between px-2  ">
                  <p className="text-[12px] text-[#053676] font-bold">00:06</p>
                  <div className="w-[20px]  h-[20px] bg-black  items-center rounded-full justify-center flex">
                    <RiVoiceprintLine color="#51F94E" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Dropdown and Conversation */}
        <div className="items-center flex flex-col pt-2 sm:hidden mb-4 px-2">
          <div className="relative inline-block text-left z-40 bg-[#D9D9D980] rounded-[25px] mb-4">
            <div
              onClick={toggleDropdown}
              className="w-[310px] h-14 items-center flex cursor-pointer justify-end bg-[#2A71E8] rounded-[25px] top-5"
            >
              <div className="items-center space-x-10 flex px-4">
                <p className="text-white font-bold">{selectedOption}</p>
                <SelectorIcon />
              </div>
            </div>

            {isOpen && (
              <div className="absolute right-0 mt-2 w-[310px] ring-1 ring-black ring-opacity-0 space-y-10 h-[56px] mr-6">
                <div className="py-1 space-y-2 rounded-[25px] items-center px-5">
                  {options.map((option) => (
                    <button
                      key={option.label}
                      onClick={() => handleOptionClick(option)}
                      className="w-[310px] bg-[#D9D9D9] px-4 py-2 rounded-[25px] h-10 items-center justify-center flex space-y-5 text-left text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Mobile Conversation Display */}
          <div className="w-[350px] h-[200px] overflow-y-auto bg-gray-50 rounded-lg p-3 border mb-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-sm font-semibold text-gray-800">Conversation</h3>
              <button 
                onClick={clearConversation}
                className="bg-red-500 text-white px-2 py-1 rounded-lg hover:bg-red-600 transition-colors text-xs"
              >
                Clear
              </button>
            </div>
            
            {conversation.length === 0 ? (
              <div className="text-center text-gray-500 mt-6">
                <p className="text-sm">Start a conversation by typing below</p>
              </div>
            ) : (
              <div className="space-y-3">
                {conversation.map((message) => (
                  <div key={message.id} className={`flex ${message.type === 'user' ? 'justify-start' : 'justify-end'}`}>
                    <div className="flex flex-col max-w-[250px]">
                      <div className={`px-3 py-2 rounded-lg text-sm ${ 
                        message.type === 'user' 
                          ? 'bg-blue-500 text-white' 
                          : 'bg-green-500 text-white'
                      }`}>
                        {message.type === 'user' ? (
                          <p>{message.content}</p>
                        ) : (
                          <div className="flex items-center justify-between">
                            <p className="text-xs font-semibold">{message.animationName}</p>
                            <button 
                              onClick={() => setPlayAnimation(prev => prev + 1)}
                              className="bg-white/20 hover:bg-white/30 rounded p-1 ml-2"
                            >
                              <FaPlay size={10} />
                            </button>
                          </div>
                        )}
                      </div>
                      <p className="text-xs text-gray-500 mt-1 text-center">
                        {message.timestamp.toLocaleTimeString()}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Desktop Animation Container */}
        <div className="hidden bg-bg6 sm:w-full w-[367px] sm:h-[550px] h-full ml-3 rounded-[30px] md:flex md:flex-col bg-cover bg-center relative">
          <button 
            onClick={() => setIsAnimationPaused(prev => !prev)}
            className="absolute top-2 right-2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full w-8 h-8 flex items-center justify-center transition-colors"
          >
            {isAnimationPaused ? <FaPlay size={14} /> : <FaPause size={14} />}
          </button>
          <div className="flex-1 w-full h-full">
            {showScene && <Scene playAnimation={playAnimation} isPaused={isAnimationPaused} />}
          </div>
          
          <div className="bg-white/90 backdrop-blur-sm rounded-b-[30px] p-4 mt-2">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Letters</h3>
            <div className="grid grid-cols-4 gap-2 text-xs">
              <button 
                className="bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                onClick={() => {
                  addUserMessage("A");
                }}
              >
                A
              </button>
              <button 
                className="bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                onClick={() => {
                  addUserMessage("B");
                }}
              >
                B
              </button>
              <button 
                className="bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                onClick={() => {
                  addUserMessage("C");
                }}
              >
                C
              </button>
              <button 
                className="bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                onClick={() => {
                  addUserMessage("D");
                }}
              >
                D
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Animation Container */}
        <div className="flex justify-center sm:hidden px-2 mb-6">
          <div className="bg-bg6 w-full max-w-sm h-[400px] rounded-[30px] flex flex-col bg-cover bg-center relative">
            <button 
              onClick={() => setIsAnimationPaused(prev => !prev)}
              className="absolute top-2 right-2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full w-8 h-8 flex items-center justify-center transition-colors"
            >
              {isAnimationPaused ? <FaPlay size={14} /> : <FaPause size={14} />}
            </button>
            <div className="flex-1 w-full h-full">
              {showScene && <Scene playAnimation={playAnimation} isPaused={isAnimationPaused} />}
            </div>
            
            <div className="bg-white/90 backdrop-blur-sm rounded-b-[30px] p-3">
              <h3 className="text-sm font-semibold text-gray-800 mb-2">Letters</h3>
              <div className="grid grid-cols-4 gap-2 text-xs">
                <button 
                  className="bg-blue-500 text-white px-2 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                  onClick={() => {
                    addUserMessage("A");
                  }}
                >
                  A
                </button>
                <button 
                  className="bg-blue-500 text-white px-2 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                  onClick={() => {
                    addUserMessage("B");
                  }}
                >
                  B
                </button>
                <button 
                  className="bg-blue-500 text-white px-2 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                  onClick={() => {
                    addUserMessage("C");
                  }}
                >
                  C
                </button>
                <button 
                  className="bg-blue-500 text-white px-2 py-1 rounded-lg hover:bg-blue-600 transition-colors"
                  onClick={() => {
                    addUserMessage("D");
                  }}
                >
                  D
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" sm:border-[1px] sm:w-[1364px] w-[123px] border-[#878787] ml-3  hidden  md:block "></div>

      <div
        className={`bg-[#D9D9D9] ${
          showmic ? "" : "hidden"
        } relative w-[363px] h-[90px] sm:hidden  rounded-[25px] mb-2 mt-2 ml-4 items-center flex justify-center`}
      >
        <RiVoiceprintLine color="#BE2117" size={80} />
        <RiVoiceprintLine color="#BE2117" size={80} />
        <h4 className="absolute right-10 text-[#053676]  bottom-5">00:06</h4>
      </div>

      {/* Mobile Input Area */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-black border-t border-gray-200 dark:border-gray-700 z-30">
        <div className="flex items-center space-x-2 p-4">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
            placeholder="Type your message here..."
            className="flex-1 rounded-[20px] bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-800 dark:text-white px-4 py-2 placeholder:text-gray-500 dark:placeholder:text-gray-400 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all h-[40px]"
          />
          <button 
            onClick={handleSendMessage}
            className="bg-[#053676] w-[40px] h-[40px] rounded-full flex justify-center items-center cursor-pointer hover:bg-[#064284] transition-colors"
          >
            <Send />
          </button>
          <button
            className={`bg-black w-[40px] h-[40px] ${
              showmic ? "" : "hidden"
            } rounded-full flex justify-center items-center cursor-pointer`}
            onClick={startrecording}
          >
            <RiVoiceprintLine
              color="#51F94E"
              size={20}
            />
          </button>
        </div>
        <Bottombar activeBar={'input'} />
      </div>
    </div>
  );
}

export default TextAndSpeachToSignLanguage;